/**
 * api接口的统一出口
 */
// 公共模块接口
import mainpageApi from '@/api/mainpage/mainpage';
// 导出接口
export default {
    //commonApi,
    mainpageApi
}

